<template>
	<!-- <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title=""> -->
	<!-- <b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill> -->
	<!-- <b-tabs id="tabsMagazzino" ref="tabsMagazzino" v-model="activeTabIndex" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs"> -->
	<b-tabs id="tabsMagazzino" ref="tabsMagazzino" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items"
		content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
		<b-tab>
			<template #title><span style="font-size: 13px">🗄️</span><span style="padding-left: 10px">Anagrafica</span>
			</template>
			<MagazzinoArticoliAnagraficaEditComponent v-show="!this.isView"
				ref="cmpMagazzinoArticoliAnagraficaEditComponent" @tipoArticolo="onTipoArticolo"
				@beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"
				@updateJsonData="onUpdateJsonData" />
			<MagazzinoArticoliViewComponent v-show="this.isView" ref="cmpMagazzinoArticoliAnagraficaViewComponent"
				@tipoArticolo="onTipoArticolo" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"
				@updateJsonData="onUpdateJsonData" />
		</b-tab>
		<b-tab>
			<template #title> <span style="font-size: 13px">🏷️</span><span style="padding-left: 10px">Codici</span>
			</template>
			<magazzino-articoli-codici-lotto-matricole-list-component
				ref="cmpMagazzinoArticoliCodiciLottoMatricoleListComponent" />
		</b-tab>
		<b-tab v-if="isFarmaco">
			<template #title> <span style="font-size: 13px">💊</span><span style="padding-left: 10px">Scheda
					Farmaco</span> </template>
			<banca-farmaci-view-component ref="cmpBancaFarmaciView" />
		</b-tab>

		<b-tab lazy v-if="!isNewArticolo">
			<template #title> <span style="font-size: 13px">🚚</span><span style="padding-left: 10px">Fornitori</span>
			</template>
			<magazzino-articoli-fornitori-list-component />
		</b-tab>
		<b-tab lazy v-if="!isNewArticolo">
			<template #title> <span style="font-size: 13px">🔗</span><span
					style="padding-left: 10px">Allegati</span></template>
			<p>Tab Tre</p>
			aggiungere allegati
		</b-tab>
		<b-tab v-if="!isNewArticolo">
			<template #title> <span style="font-size: 13px">🪙</span> <span style="padding-left: 10px">Storico
					Contabile</span> </template>
			<div>
				<MagazzinoArticoliStoricoMovimentazioneContabilitaComponent
					ref="cmpMagazzinoArticoliListComponentContabilita" />
			</div>
		</b-tab>
		<b-tab v-if="!isNewArticolo">
			<template #title> <span style="font-size: 13px">📦</span> <span style="padding-left: 10px">Storico
					Giacenza</span> </template>
			<!-- //cmpMagazzinoArticoliListComponentGiacenza -->
			<MagazzinoArticoliStoricoMovimentazioneGiacenzaComponent :tableHideColumn="['actions']" :component="true"
				ref="cmpMagazzinoArticoliListComponentGiacenza" />
		</b-tab>
		<b-tab v-if="isDistintaBase" id="distintaBaseTab" :disabled="!isDistintaBase && isAnagraficaComplete">
			<template #title> <span style="font-size: 13px">📚</span><span style="padding-left: 10px">Distina
					Base</span> </template>
			<MagazzinoArticoliDistinaBaseComponent @updateDistintaBase="onUpdateDistintaBase"
				ref="cmpMagazzinoArticoliDistinaBaseComponent" />
		</b-tab>
	</b-tabs>
	<!-- </b-card> -->
</template>

<script>
import MagazzinoArticoliAnagraficaEditComponent from "./MagazzinoArticoliAnagraficaEditComponent.vue";
import MagazzinoArticoliViewComponent from "./MagazzinoArticoliViewComponent.vue";
import MagazzinoArticoliFornitoriListComponent from "./MagazzinoArticoliFornitoriListComponent.vue";
import BancaFarmaciViewComponent from "../../bancafarmaci/components/BancaFarmaciViewComponent.vue";
// import MagazzinoArticoliStoricoContabileComponent from "./MagazzinoArticoliStoricoContabileComponent.vue";
// import MagazzinoArticoliStoricoGiacenzeComponent from "./MagazzinoArticoliStoricoGiacenzeComponent.vue";
import MagazzinoArticoliCodiciLottoMatricoleListComponent from "./MagazzinoArticoliCodiciLottoMatricoleListComponent.vue";
import MagazzinoArticoliStoricoMovimentazioneGiacenzaComponent from "./MagazzinoArticoliStoricoMovimentazioneGiacenzaComponent.vue"
import MagazzinoArticoliStoricoMovimentazioneContabilitaComponent from "./MagazzinoArticoliStoricoMovimentazioneContabilitaComponent.vue";
import MagazzinoArticoliDistinaBaseComponent from "./MagazzinoArticoliDistinaBaseComponent.vue"

export default {
	name: "MagazzinoArticoliEditComponent",
	components: { MagazzinoArticoliDistinaBaseComponent, MagazzinoArticoliStoricoMovimentazioneContabilitaComponent, MagazzinoArticoliStoricoMovimentazioneGiacenzaComponent, MagazzinoArticoliCodiciLottoMatricoleListComponent, MagazzinoArticoliAnagraficaEditComponent, MagazzinoArticoliViewComponent, MagazzinoArticoliFornitoriListComponent, BancaFarmaciViewComponent },
	data() {
		return {
			activeTabIndex: 0,
			btnSaveVisible: true,
			showModalLoading: false,
			visibleColumnArray: ["documento", "prezzoUnitario", "quantita", "causaleDocumentoOperazioneMagazzino"],
			linkback: "/magazzino/articoli",
			pathResource: "/magazzinoarticoli",
			jsonData: {},
			isNewArticolo: false,
			isFarmaco: false,
			isDistintaBase: false,
			isView: false,
			codiceArticolo: null,
			id: null,
		};
	},
	computed: {
		// Determina quale componente usare basandosi sulla route
		currentAnagraficaComponent() {
			if (this.isView) {
				return "MagazzinoArticoliViewComponent";
			}
			return "MagazzinoArticoliAnagraficaEditComponent";
		},
		isAnagraficaComplete() {
			if (this.jsonData) {
				if (this.jsonData.nomeArticolo == null || this.jsonData.nomeArticolo == "") {
					return false;
				}
				if (this.jsonData.umId == null || this.jsonData.umId == "") {
					return false;
				}
			} else {
				return false;
			}
			return true
		},

	},
	created() { },
	mounted() {
		let me = this;
		me.isView = me.$route.path.includes("/view/");
		me.id = this.$route.params.id;
		if (me.id == null || me.id == "-1") {
			me.isNewArticolo = true;
		} else {
			me.isNewArticolo = false;
		}
	},

	methods: {
		init(jsonData) {
			this.jsonData = jsonData
		},


		onUpdateJsonData(jsonData) {
			let me = this;
			this.jsonData = jsonData;
			me.codiceArticolo = jsonData.codiceArticolo;
			me.$emit("updateJsonData", jsonData);
		},

		onUpdateDistintaBase(item) {
			this.jsonData.distintaBase = item;
			this.onUpdateJsonData(this.jsonData)
		},
		onTipoArticolo(tipoArticolo) {
			let me = this;
			console.log(tipoArticolo);
			me.isFarmaco = false;
			me.isDistintaBase = false;
			if (tipoArticolo == "DSB") {
				me.isDistintaBase = true;
			} else if (tipoArticolo == "FRM") {
				me.isFarmaco = true;
			}

		},
		/* onSalvaAnagraficaArticolo() {
			let me = this;
			me.$refs.cmpMagazzinoArticoliAnagraficaEdit.salvaAnagraficaArticolo();
		}, */

		onBeforeLoadData() {
			let me = this;
			me.$emit("beforeLoadData");
		},
		onAfterLoadData() {
			let me = this;
			me.$emit("afterLoadData");
		},
		onInputTabs() {
			let me = this;
			me.activeTab(me.activeTabIndex);
		},
		activeTab(idIndexTab) {
			console.log(idIndexTab);

			if (this.isView) {

				if (this.isFarmaco) {
					if (idIndexTab == 5) {
						this.$refs.cmpMagazzinoArticoliListComponentContabilita.init({ idArticolo: this.id });
						// this.$refs.cmpMagazzinoArticoliStoricoContabile.init({ idArticolo: this.id });
					}
					if (idIndexTab == 6) {
						this.$refs.cmpMagazzinoArticoliListComponentGiacenza.init({ idArticolo: this.id });
					}
					if (idIndexTab == 2) {
						this.$refs.cmpBancaFarmaciView.init(this.jsonData.codiceAic);
					}
					if (idIndexTab == 1) {
						this.$refs.cmpMagazzinoArticoliCodiciLottoMatricoleListComponent.init(this.jsonData.id);
					}
				} else {
					if (idIndexTab == 4) {
						this.$refs.cmpMagazzinoArticoliListComponentContabilita.init({ idArticolo: this.id });
						//this.$refs.cmpMagazzinoArticoliStoricoContabile.init({ idArticolo: this.id });
					}
					if (idIndexTab == 5) {
						this.$refs.cmpMagazzinoArticoliListComponentGiacenza.init({ idArticolo: this.id });
						//this.$refs.cmpMagazzinoArticoliListComponentGiacenza.loadDataArticoli({ idArticolo: this.id });
					}
					if (idIndexTab == 6) {
						this.$refs.cmpMagazzinoArticoliDistinaBaseComponent.init({ idArticolo: this.id }, this.jsonData)
						//this.$refs.cmpMagazzinoArticoliListComponentGiacenza.loadDataArticoli({ idArticolo: this.id });
					}
				}
			} else {

				if (idIndexTab == 0) {
					this.$refs.cmpMagazzinoArticoliAnagraficaEditComponent.init(this.jsonData);
					// this.$refs.cmpMagazzinoArticoliStoricoContabile.init({ idArticolo: this.id });
				}
				if (idIndexTab == 3) {
					this.$refs.cmpMagazzinoArticoliDistinaBaseComponent.init({ idArticolo: this.id }, this.jsonData);
					// this.$refs.cmpMagazzinoArticoliStoricoContabile.init({ idArticolo: this.id });
				}
				if (idIndexTab == 4) {
					//this.$refs.cmpMagazzinoArticoliListComponentGiacenza.loadDataArticoli({ idArticolo: this.id });
				}
				if (idIndexTab == 6) {
					this.$refs.cmpMagazzinoArticoliDistinaBaseComponent.init({ idArticolo: this.id }, this.jsonData)

				}
			}
		},
	},
};
</script>

<style></style>
